import React, { useCallback, useState } from 'react'
import cls from 'classnames'
import styled from 'styled-components'

import { MiniIcon } from 'components/lib/Badge'
import Tooltip from 'components/lib/DesignSystem/Tooltip'

function IconItem({
  className,

  title,
  iconURL,
  iconID,
  onClick,
  badgeHasDone,
  active,

  PopupComponent,
}) {
  const [dropdownShown, setDropdownShown] = useState(0)
  const [badgeCount, setBadgeCount] = useState(0)
  const [disableTitle, setDisableTitle] = useState(false)
  const [onClickCallback, setOnClickCallback] = useState(() => onClick)
  const setOnClickCallbackWrapper = useCallback(
    (callback) => setOnClickCallback(() => callback),
    []
  )

  const handleIconClick = useCallback(() => {
    setDisableTitle(true)
    onClickCallback?.()
  }, [onClickCallback])

  const onCloseCallback = useCallback(() => setDisableTitle(false), [])

  const showDoneBadge = !badgeCount && badgeHasDone

  return (
    <div className={cls(className, 'gt-p')}>
      <Tooltip text={title} arrow open={disableTitle ? false : undefined}>
        <div
          className={cls('toggle-icon', { active: dropdownShown || active })}
          onClick={handleIconClick}
        >
          <img id={iconID} src={iconURL} />
          {(badgeCount > 0 || badgeHasDone) && (
            <MiniIcon
              className="bell-badge"
              top="0"
              left="33px"
              padding={showDoneBadge && '0'}
              backgroundColor={showDoneBadge && 'transparent'}
            >
              {showDoneBadge ? (
                <img
                  style={{ width: '13px', height: '13px' }}
                  src={`${STATIC_BASE_URL}/static/webapp/images/navigation/valid-icon.svg`}
                />
              ) : (
                badgeCount
              )}
            </MiniIcon>
          )}
        </div>
      </Tooltip>
      {PopupComponent &&
        React.cloneElement(PopupComponent, {
          setBadgeCount,
          setOnClickCallback: setOnClickCallbackWrapper,
          setDropdownShown,
          onCloseCallback,
        })}
    </div>
  )
}

export default styled(React.memo(IconItem))`
  position: relative;
  display: inline-block;
  height: 50px;
  .toggle-icon {
    padding: 12px;
    border-radius: 50%;
    position: relative;
    cursor: pointer;
    &:focus:not(:focus-visible) {
      outline: none;
    }
    &:hover::before {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      content: ' ';
      position: absolute;
      top: 0;
      left: 0;
      z-index: -1;
      background-color: var(--top-navigation-item-hover-bg);
    }
    &.active {
      background-color: var(--ds-bg-periwinkle);
    }
  }
`
